import React from "react";

export default function loader() {


    return <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>;
};